import moment from 'moment'

const DATE_FORMAT = 'DD.MM.YYYY'
const STATUS_PROCESS = 'PROCESS'

const TRANSACTION_TYPE_KEYS = {
  ANY: 'reports.paymentTypes.all',
  DEBIT: 'reports.paymentTypes.debit',
  CREDIT: 'reports.paymentTypes.credit',
}

function formatTimestamp(value) {
  return moment.utc(value * 1000).format(DATE_FORMAT)
}

class Report {
  constructor(report) {
    this.model = report
  }

  get description() {
    return this.model.description
  }

  get fileName() {
    return this.model.fileName
  }

  get id() {
    return this.model.id
  }

  get downloadUrl() {
    return this.model.url
  }

  // need to refactor when backend will update time formats
  get dateRange() {
    return `${formatTimestamp(this.model.data.dateFrom)}-${formatTimestamp(
      this.model.data.dateTo,
    )}`
  }

  get iconName() {
    return this.model.data.format.toLowerCase()
  }

  get format() {
    return this.model.data.format.toUpperCase()
  }

  get includeFeePaymentKey() {
    return this.model.data.includeFeePayment
      ? 'reports.feeStates.included'
      : 'reports.feeStates.excluded'
  }

  get transactionsTypeKey() {
    return (
      TRANSACTION_TYPE_KEYS[this.model.data.type] || 'reports.paymentTypes.all'
    )
  }

  get walletId() {
    return this.model.data.walletId
  }

  get isProcessing() {
    return this.model.status === STATUS_PROCESS
  }
}

export const ReportItemDecorator = (item) => {
  return new Report(item)
}

export const ReportListDecorator = (items) => {
  return items.map((item) => {
    return ReportItemDecorator(item)
  })
}
